import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Disc3 } from "lucide-react";
import session from "../Utils/session";
import config from "../Utils/config";

/**
 * Vertical navigation rail. Desktop only — mobile keeps the slim top Header.
 * Sits at fixed top-0 left-0 bottom-0 with a width of `w-14` (56px).
 */
function Rail() {
  const navigate = useNavigate();
  const location = useLocation();
  const username = session.getUsername();

  const onProfileRoute =
    location.pathname === "/app/me" || location.pathname.startsWith("/app/u/");
  const onHome = location.pathname === "/app";
  const onDj = location.pathname.startsWith("/app/dj");

  return (
    <aside className="hidden lg:flex fixed top-0 left-0 bottom-0 w-14 z-50 bg-secondary border-r border-neutral-800 flex-col items-center py-3 gap-1">
      {/* Brand mark */}
      <div className="text-[8px] uppercase tracking-[0.4em] text-text-dim font-bold leading-none mb-2 select-none">
        MZ
      </div>

      {/* Avatar — links to my profile */}
      <RailItem
        active={onProfileRoute}
        accent="blue"
        onClick={() => navigate("/app/me")}
        label="Profile"
      >
        <img
          src={`${config.serverUrl}/users/profile/${username}/avatar`}
          alt=""
          className="w-7 h-7 rounded-full object-cover border border-neutral-700"
        />
      </RailItem>

      <div className="w-6 h-px bg-neutral-800 my-1" aria-hidden />

      <RailItem
        active={onHome}
        accent="blue"
        onClick={() => navigate("/app")}
        label="Home"
      >
        <Home className="w-4 h-4" strokeWidth={2.25} />
      </RailItem>

      <RailItem
        active={onDj}
        accent="pink"
        onClick={() => navigate("/app/dj")}
        label="DJ"
      >
        <Disc3 className="w-4 h-4" strokeWidth={2.25} />
      </RailItem>
    </aside>
  );
}

function RailItem({ active, accent = "blue", onClick, label, children }) {
  const accentText = accent === "pink" ? "text-pink-300" : "text-blue-300";
  const stripeBg = accent === "pink" ? "bg-pink-500" : "bg-blue-500";
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-label={label}
      className={`relative w-10 h-10 rounded-md flex items-center justify-center transition-colors ${
        active
          ? `bg-neutral-900 ${accentText}`
          : "text-text-muted hover:bg-neutral-800 hover:text-text"
      }`}
    >
      {active && (
        <span
          className={`absolute -left-3 top-1.5 bottom-1.5 w-0.5 rounded-r ${stripeBg}`}
          style={{
            boxShadow: accent === "pink" ? "0 0 6px rgba(236,72,153,0.6)" : "0 0 6px rgba(59,130,246,0.6)",
          }}
          aria-hidden
        />
      )}
      {children}
    </button>
  );
}

export default Rail;
